<template>
  <div class="rte">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    this.updateTitle(); // 确保在组件加载后立即更新标题
  },
  watch: {
    '$route'() {
      this.updateTitle(); // 监听路由变化，更新标题
    }
  },
  methods: {
    updateTitle() {
      const pageTitle = '东方环球'; // 固定部分的标题内容
      const routeTitle = this.$route.meta.title || ''; // 当前路由的标题内容
      document.title = `${pageTitle}_${routeTitle}`;
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
.rte{
  height:100%;
}
  .el-input__inner{
  border-radius: 0;
}
</style>
